var _path, _g, _path2, _g2, _g3, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKoreanFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Flags-5",
    clipPath: "url(#clip0_3427_18938)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 0.25H2.5C1.5335 0.25 0.75 1.0335 0.75 2V10C0.75 10.9665 1.5335 11.75 2.5 11.75H10.5C11.4665 11.75 12.25 10.9665 12.25 10V2C12.25 1.0335 11.4665 0.25 10.5 0.25Z",
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3427_18938",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 12
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5 0.25H2.5C1.5335 0.25 0.75 1.0335 0.75 2V10C0.75 10.9665 1.5335 11.75 2.5 11.75H10.5C11.4665 11.75 12.25 10.9665 12.25 10V2C12.25 1.0335 11.4665 0.25 10.5 0.25Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3427_18938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 8.79971C7.60457 8.79971 8.5 7.54611 8.5 5.99971C8.5 4.45331 7.60457 3.19971 6.5 3.19971C5.39543 3.19971 4.5 4.45331 4.5 5.99971C4.5 7.54611 5.39543 8.79971 6.5 8.79971Z",
    fill: "#E01B41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3427_18938",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 5,
    height: 6
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 8.79971C7.60457 8.79971 8.5 7.54611 8.5 5.99971C8.5 4.45331 7.60457 3.19971 6.5 3.19971C5.39543 3.19971 4.5 4.45331 4.5 5.99971C4.5 7.54611 5.39543 8.79971 6.5 8.79971Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3427_18938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50006 6.4C5.07149 7.15 5.92863 7.6 6.50006 6.4C7.07149 5.2 8.21435 5.2 8.50006 6.4C8.78578 7.6 8.50006 8.8 8.50006 8.8H4.50006C4.50006 8.8 3.92863 5.65 4.50006 6.4Z",
    fill: "#0E4B9C"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.09593 2.25484C3.16292 2.0924 3.32801 2.05026 3.46467 2.16071C3.60132 2.27117 3.6578 2.4924 3.59081 2.65484L2.97626 4.14505C2.90927 4.30749 2.74418 4.34963 2.60752 4.23917C2.47087 4.12872 2.41439 3.90749 2.48138 3.74504L3.09593 2.25484ZM9.5358 2.16087C9.39915 2.27133 9.34267 2.49256 9.40966 2.655L10.0242 4.1452C10.0912 4.30765 10.2563 4.34979 10.3929 4.23933C10.5296 4.12888 10.5861 3.90765 10.5191 3.7452L9.90454 2.255C9.83754 2.09256 9.67246 2.05041 9.5358 2.16087ZM8.7934 2.76098C8.65675 2.87144 8.60027 3.09267 8.66726 3.25511L9.28181 4.74531C9.3488 4.90776 9.51389 4.9499 9.65054 4.83944C9.7872 4.72898 9.84367 4.50776 9.77668 4.34531L9.16213 2.85511C9.09514 2.69267 8.93006 2.65052 8.7934 2.76098ZM2.48132 8.25491C2.41433 8.09247 2.4708 7.87124 2.60746 7.76078C2.74411 7.65033 2.9092 7.69247 2.97619 7.85491L3.59074 9.34512C3.65773 9.50756 3.60126 9.72879 3.4646 9.83925C3.32795 9.9497 3.16286 9.90756 3.09587 9.74512L2.48132 8.25491ZM3.34986 7.16068C3.2132 7.27113 3.15673 7.49236 3.22372 7.6548L3.83827 9.14501C3.90526 9.30745 4.07035 9.34959 4.207 9.23914C4.34366 9.12868 4.40013 8.90745 4.33314 8.74501L3.71859 7.2548C3.6516 7.09236 3.48651 7.05022 3.34986 7.16068ZM9.28188 7.2549C9.34887 7.09246 9.51395 7.05032 9.65061 7.16077C9.78727 7.27123 9.84374 7.49246 9.77675 7.6549L9.1622 9.1451C9.09521 9.30755 8.93012 9.34969 8.79347 9.23923C8.65681 9.12878 8.60034 8.90755 8.66733 8.7451L9.28188 7.2549ZM10.3929 7.76088C10.2563 7.65043 10.0912 7.69257 10.0242 7.85501L9.40964 9.34522C9.34265 9.50766 9.39912 9.72889 9.53578 9.83934C9.67243 9.9498 9.83752 9.90766 9.90451 9.74522L10.5191 8.25501C10.586 8.09257 10.5296 7.87134 10.3929 7.76088ZM4.20698 2.76082C4.07032 2.65037 3.90523 2.69251 3.83824 2.85495L3.22369 4.34515C3.1567 4.5076 3.21318 4.72883 3.34983 4.83928C3.48649 4.94974 3.65157 4.9076 3.71857 4.74516L4.33311 3.25495C4.40011 3.09251 4.34363 2.87128 4.20698 2.76082Z",
    fill: "#262626"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3427_18938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoreanFlag);
export default __webpack_public_path__ + "static/media/KoreanFlag.b82ada422c4d649770ffc88e8bb54a54.svg";
export { ForwardRef as ReactComponent };